/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

require("modern-normalize")

const { OpenPanel } = require("@openpanel/web")

exports.onClientEntry = () => {
  const clientId = process.env.GATSBY_OPENPANEL_CLIENT_ID
  const apiUrl = process.env.GATSBY_OPENPANEL_API_URL

  if (!clientId) return

  const op = new OpenPanel({
    clientId,
    apiUrl,
    trackScreenViews: true,
    trackOutgoingLinks: true,
    trackAttributes: true,
  })

  if (typeof window !== "undefined") {
    window.op = op
  }
}
